import { useState, useEffect } from "react";
import InfoIcon from '@mui/icons-material/Info';

/**
 * 
 * @returns 
 */
export default function CreditCardNumber(props) {

  const handleChange = (ev) => {
    ev.stopPropagation();
    let str = ev.target.value.replace(/[^\d]/g, ""); // Remove non-digits


    // Limit to 16 digits (standard card length)
    if (str.length > 16) str = str.slice(0, 16);

    // Add space every 4 digits
    let formatted = str.replace(/(.{4})/g, "$1 ").trim();
    
    // Call parent onChange if provided
    if (props.onChange) {
      // Create a synthetic event with formatted value
      props.onChange({ ...ev, target: { ...ev.target, value: formatted } });
    }

  }

  return (
    <input {...props} onChange={handleChange} />
  );
}
